var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"my-5",attrs:{"indeterminate":""}}),_c('base-subheading',[_vm._v(_vm._s(_vm.$t("global.please_wait_server")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }